import React from 'react';
import { Tabs, Tab, Box, Grid, IconButton } from '@material-ui/core';
import { BackButton, ButtonSubmit, Container, Panel } from '../../../../Components';
import { useStyles } from './Customer.styles';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { useLocation } from "react-router";
import { TextField2 } from '../../../../Components/Field';
import { useNavigate } from 'react-router-dom';
import { UserCustomerList } from './UserCustomerList';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import CustomerServicesApi from '../../../../Redux/Actions/CustomerAction';
import CopyIcon from '../../../../Assets/Images/copyIcon.png'
import { Alert, AlertTitle } from '@material-ui/lab';
import { useSnackbar } from 'notistack';
interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}
type clientUdate = {
  companyName: string;
  organisationId: string | number;
  mobile: string | number;
}
function TabPanel(props: TabPanelProps) {
  const classes = useStyles();
  const { children, value, index, ...other } = props;
  return (
    <div className={classes.tabPannel}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}
function tabProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
export const ClientUpdateForm = () => {
  const { apiToken, customerCreate } = useSelector((state: any) => ({
    apiToken: state?.UserReducer?.apiToken,
    customerCreate: state?.CustomerReducer?.customerCreate,
  }))
  const classes = useStyles();
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);;
  const [ClientUpdate, setClientUpdate] = React.useState<clientUdate>({ companyName: '', organisationId: '', mobile: '' })
  const [passwordShow, setPasswordHide] = React.useState(false);
  const [coped, setCoped] = React.useState(false);
  const [hover, sethover] = React.useState(false);
  const [editClient, setEditClient] = React.useState(false);
  const dispatch: any = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { formatMessage } = useIntl();
  const handleChange = (event:any,newValue: number) => {
    setValue(newValue);
  };
  const user = useLocation().state.userRowData;
  React.useEffect(() => {
    setClientUpdate(user)
  }, [])
  const editClientDetail = () => {
    if (user.id) {
      const updateClient = {
        id: user?.id,
        companyName: ClientUpdate?.companyName,
        organisationId: ClientUpdate?.organisationId,
        mobile: ClientUpdate?.mobile,
        email: user?.email,
        ftpUserName: user?.ftpUserName,
        ftpPassword: user?.ftpPassword,
        ftpDirectory: user?.ftpDirectory
      }
      dispatch(CustomerServicesApi?.AddClientAdmin(updateClient, undefined, apiToken,enqueueSnackbar));
      if (customerCreate) {
        setEditClient(true);
        navigate('/administration/customer');
        alert("update");
      }
    } else {
      alert("please fill detaill")
    }
  }
  const copyPassword = () => {
    navigator?.clipboard?.writeText(user?.ftpPassword)
    setCoped(true)
    const timeId = setTimeout(() => {
      setCoped(false)
    }, 2000)
    return () => {
      clearTimeout(timeId)
    }
  }
  return (
    <Container fullWidth>
      <Grid container justifyContent="flex-start">
        <BackButton link={"/administration/customer"} />
      </Grid>
      <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" indicatorColor="primary" textColor="primary">
        <Tab label={formatMessage({ id: "customer.tab.client", defaultMessage: "Client" })} {...tabProps(0)} />
        <Tab label={formatMessage({ id: "customer.tab.ftpDetail", defaultMessage: "FTP Detail" })} {...tabProps(1)} />
        <Tab label={formatMessage({ id: "customer.tab.users", defaultMessage: "Users" })} {...tabProps(2)} />
      </Tabs>
      <TabPanel value={value} index={0}>
        <Panel>
          <Grid container >
            <Grid item xs={2} className={classes.marginTop15}>{formatMessage({ id: "customer.update.name", defaultMessage: "Name" })}</Grid>{editClient ? <Grid item >: {user?.companyName}</Grid> : <Grid><TextField2 onChange={(str: string) => setClientUpdate({ ...ClientUpdate, companyName: str })} placeholder={''} value={ClientUpdate.companyName} /></Grid>}
          </Grid>
          <Grid container className={classes.marginTop15}>
            <Grid item xs={2}>{formatMessage({ id: "customer.update.email", defaultMessage: "Email" })}</Grid><Grid item xs={5}>: {user?.contactPerson}</Grid>
          </Grid>
          <Grid container className={classes.margin10}>
            <Grid item xs={2} className={classes.marginTop10}>{formatMessage({ id: "customer.update.organisationId", defaultMessage: "Organisation Id" })}</Grid>{editClient ? <Grid item >: {user?.organisationId}</Grid> : <Grid><TextField2 onChange={(str: string) => setClientUpdate({ ...ClientUpdate, organisationId: str })} placeholder={''} value={ClientUpdate.organisationId} /></Grid>}
          </Grid>
          <Grid container>
            <Grid item xs={2} className={classes.marginTop10}>{formatMessage({ id: "customer.update.mobile", defaultMessage: "Mobile Name" })}</Grid>{editClient ? <Grid item >:  {user?.mobile}</Grid> : <Grid><TextField2 onChange={(str: string) => setClientUpdate({ ...ClientUpdate, mobile: str })} placeholder={''} value={ClientUpdate.mobile} /></Grid>}
          </Grid>
          <Grid container justifyContent={'flex-end'}>
            <ButtonSubmit text={editClient ? 'admin.users.invite.edit' : 'admin.users.invite.update'} onClick={editClientDetail} />
          </Grid>
        </Panel>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Panel>
          <Grid container>
            <Grid item xs={2} className={classes.font}>{formatMessage({ id: "customer.create.ftpUser", defaultMessage: "FTP User" })}</Grid><Grid item xs={2} className={classes.font}>: {user?.ftpUserName}</Grid>
          </Grid>
          <Grid container className={classes.marginTop15}>
            <Grid item xs={2} className={classes.font}>{formatMessage({ id: "customer.create.password", defaultMessage: "Password" })}</Grid>
            {passwordShow ? <Grid item className={classes.font}>:{user?.ftpPassword}</Grid> : <>:&nbsp;{[...Array(user?.ftpPassword?.length)].map((e, i) => <Grid key={i} className={(classes.marginTop5, classes.font)}> *</Grid>)}</>}
            <IconButton onClick={() => setPasswordHide(!passwordShow)} className={classes.passwordIcon}>
              {passwordShow ? <Visibility /> : <VisibilityOff />}
            </IconButton>
            <IconButton onClick={copyPassword} className={classes.copyButton}
            onMouseOver={() => sethover(true)}
            onMouseOut={() => sethover(false)}
            >
              <img src={CopyIcon} alt="copyIcon" className={classes.copyImage} />
            </IconButton>
            {coped ?
              <Alert severity="success" className={classes.alertToast}>
                <AlertTitle >{formatMessage({ id: "customer.tost.copy", defaultMessage: "Coped!" })}</AlertTitle>
              </Alert>
              : null}
              <Grid >
            {hover?(<label className={classes.marginLeft10}>{coped?null:formatMessage({ id: "customer.tost.copyHere", defaultMessage: "Copy here!" })}</label>):null}
          </Grid>
          </Grid>
        </Panel>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <UserCustomerList customerid={user?.id} />
      </TabPanel>
    </Container>
  )
} 